module.exports = __webpack_public_path__ + "static/media/Digiwrap.png.png.2bd4f23b.webp";